import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Radio } from 'antd';
import { TypeRadio, TypeRadioWrapper, TypeWrapper, TypeName } from './styled';
import EntityIcon from './EntityIcon';
var TypeStep = function (_a) {
    var selectEntityType = _a.selectEntityType;
    return (_jsx(TypeWrapper, { children: _jsx(Radio.Group, { onChange: function (e) { return selectEntityType(e.target.value); }, style: { minWidth: '100%' }, children: _jsxs(TypeRadioWrapper, { children: [_jsxs(TypeRadio, { value: "provider", "data-test": "providerSelectBtn", children: [_jsx(EntityIcon, {}), _jsx(TypeName, { children: "Provider Care Plan" })] }), _jsxs(TypeRadio, { value: "facility", "data-test": "facilitySelectBtn", children: [_jsx(EntityIcon, { isFacility: true }), _jsx(TypeName, { children: "Facility Care Plan" })] })] }) }) }));
};
export default TypeStep;
